/* Copyright (c) 2019 - 2021. Verimatrix. All Rights Reserved.
   All information in this file is Verimatrix Confidential and Proprietary. */

import React from "react";
import { Segment, Container, Grid, Header, List } from "semantic-ui-react";
import styles from "./LandingFooter.module.css";
import verimatrixLogo from "./verimatrixLogo.png";
import "./LandingFooter.css";
import { useTranslation } from "react-i18next";

interface LandingFooterProps {
  changeState?: any;
}

const LandingFooter: React.FC<LandingFooterProps> = ({ changeState }) => {
  const { t } = useTranslation(["footer", "common"]);

  const footerLogoSection = () => {
    return (
      <Grid
        inverted
        stackable
        style={{ marginTop: "3rem", marginBottom: "2rem" }}
      >
        <Grid.Row>
          <Grid.Column floated="left" verticalAlign="middle" width="5">
            <a
              href="https://www.verimatrix.com"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img alt="Verimatrix Logo" src={verimatrixLogo} width="270" />
            </a>
          </Grid.Column>
        </Grid.Row>
      </Grid>
    );
  };

  return (
    <React.Fragment>
      <Segment basic inverted id={styles.footerSegment}>
        <Container>
          <Grid inverted divided stackable columns="equal">
            <Grid.Row>
              <Grid.Column stretched verticalAlign="top">
                <Header as="h4" className={styles.footerHeader}>
                  {t("follow_us")}
                </Header>
                <List inverted>
                  <List.Item
                    icon="twitter"
                    content={
                      <a
                        href="https://twitter.com/verimatrixinc"
                        target="_blank"
                        rel="noopener noreferrer"
                        className={styles.footerLink}
                      >
                        Twitter
                      </a>
                    }
                  />
                  <List.Item
                    icon="linkedin"
                    content={
                      <a
                        href="https://www.linkedin.com/company/verimatrix"
                        target="_blank"
                        rel="noopener noreferrer"
                        className={styles.footerLink}
                      >
                        LinkedIn
                      </a>
                    }
                  />
                </List>
              </Grid.Column>
              {changeState && (
                <Grid.Column stretched verticalAlign="top">
                  <Header as="h4" className={styles.footerHeader}>
                    {t("user")}
                  </Header>
                  <List inverted>
                    <List.Item
                      content={
                        <a href="/login" className={styles.footerLink}>
                          {t("common:log_in")}
                        </a>
                      }
                    />
                  </List>
                </Grid.Column>
              )}
              <Grid.Column stretched verticalAlign="top">
                <Header as="h4" className={styles.footerHeader}>
                  {t("about_us")}
                </Header>
                <List inverted>
                  <List.Item
                    content={
                      <a
                        href="https://www.verimatrix.com/about-us"
                        target="_blank"
                        rel="noopener noreferrer"
                        className={styles.footerLink}
                      >
                        Verimatrix
                      </a>
                    }
                  />
                  <List.Item
                    content={
                      <a
                        href="https://www.verimatrix.com/solutions/application-shielding/"
                        target="_blank"
                        rel="noopener noreferrer"
                        className={styles.footerLink}
                      >
                        {t("app_shielding")}
                      </a>
                    }
                  />
                  <List.Item
                    content={
                      <a
                        href="https://www.verimatrix.com/products/app-shield/plans/"
                        target="_blank"
                        rel="noopener noreferrer"
                        className={styles.footerLink}
                      >
                        {t("plans")}
                      </a>
                    }
                  />
                </List>
              </Grid.Column>
              <Grid.Column stretched verticalAlign="top">
                <Header as="h4" className={styles.footerHeader}>
                  {t("vmx_hq")}
                </Header>
                <List inverted link>
                  <List.Item content={"Impasse des carrés de l’Arc"} />
                  <List.Item content={"Rond-point du Canet"} />
                  <List.Item content={"13590 Meyreuil"} />
                  <List.Item content={"FRANCE"} />
                </List>
              </Grid.Column>
            </Grid.Row>
          </Grid>

          {footerLogoSection()}
        </Container>
      </Segment>

      <Segment basic inverted id={styles.copyrightSegment}>
        <Container>
          <Grid
            inverted
            divided
            stackable
            columns="4"
            style={{ padding: "6px" }}
          >
            <Grid.Column stretched className={styles.listPadding} width={6}>
              Copyright © 2022 Verimatrix, All Rights Reserved
            </Grid.Column>
            <Grid.Column stretched className={styles.listPadding} width={3}>
              <a href="/terms" className={styles.footerLink}>
                {t("common:terms_and_conditions")}
              </a>
            </Grid.Column>
            <Grid.Column stretched className={styles.listPadding} width={3}>
              <a
                href="https://www.verimatrix.com/privacy/"
                target="_blank"
                rel="noopener noreferrer"
                className={styles.footerLink}
              >
                {t("common:privacy_notice")}
              </a>
            </Grid.Column>
            <Grid.Column
              stretched
              className={styles.listPadding}
              width={3}
              verticalAlign="top"
            >
              <button
                id="ot-sdk-btn"
                className={`ot-sdk-show-settings ${styles.cookieSettingsButton}`}
              >
                {t("cookie_settings")}
              </button>
            </Grid.Column>
          </Grid>
        </Container>
      </Segment>
    </React.Fragment>
  );
};

export default LandingFooter;
